import { render, staticRenderFns } from "./envSafKpiNearAccident.vue?vue&type=template&id=560a9bcf"
import script from "./envSafKpiNearAccident.vue?vue&type=script&lang=js"
export * from "./envSafKpiNearAccident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('560a9bcf')) {
      api.createRecord('560a9bcf', component.options)
    } else {
      api.reload('560a9bcf', component.options)
    }
    module.hot.accept("./envSafKpiNearAccident.vue?vue&type=template&id=560a9bcf", function () {
      api.rerender('560a9bcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/esk/envSafKpiNearAccident.vue"
export default component.exports